<template>
  <div class="footer">
    <el-row>
      <el-col :span="5"><div class="grid-content"></div></el-col>
      <el-col :span="14" class="el_center">
        <el-row>
          <el-col :span="12">
            <div class="el_center_top">
              <!-- <span class="title_max">活动云平台</span>
                       <span class="name_small">Activity cloud platform</span> -->
              <div class="footermenu">
                <router-link to="/">首页</router-link><label></label>
                <router-link to="/my">个人中心</router-link>
              </div>
            </div>
            <div class="el_center_bottom">
              北京一博千禧科技有限公司<br />
              电信信息业务许可证：京B2-20180237<br />
              广播电视节目制作经营许可证：（京）字第16582号<br />
              Copyright@2019-2029语林 All Rights Reserved &nbsp;&nbsp;
              &nbsp;&nbsp;
              <a
                target="_blank"
                class="link_style_none"
                href="https://beian.miit.gov.cn/#/Integrated/index"
                >京ICP备16011149号-6</a
              ><br />
              <p>
                <a
                  target="_blank"
                  class="record"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802037573"
                >
                  <img
                    class="record_img"
                    src="../assets/images/ba.png"
                    alt=""
                  />
                  <p class="text">京公网安备11010102007034号</p>
                </a>
              </p>
            </div>
          </el-col>
          <el-col :span="12" class="el_col_right">
            <div class="el_center_right_top">
              <img class="ewm" src="../../src/assets/images/ewm_dl.jpg" />
            </div>
            <div class="el_center_right_bottom">
              服务热线：400-969-6261 <br />
              （如对平台内容有任何疑问，请与我们联系)
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "LoginFooter",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
.footer {
  width: 1920px;
  height: 300px;
  background: white;
  border-top: 10px solid #ffb463;
}
.grid-content {
  height: 200px;
  display: flex;
  justify-content: left;
}
.el_center {
  display: flex;
  flex-direction: column;
}
.el_center_top {
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.el_center_bottom {
  height: 100px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  justify-content: center;
}
.title_max {
  display: inline-table;
  font-size: 35px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #999999;
  justify-content: center;
}
.name_small {
  display: inline-table;
  margin-top: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  justify-content: center;
  margin-left: 10px;
}
.el_center_right_top {
  height: 110px;
  padding-top: 10px !important;
  box-sizing: border-box !important;
  text-align: right !important;
}
.ewm {
  width: 110px;
  height: 110px;
  background: white;
}
.el_center_right_bottom {
  height: 100px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  text-align: right !important;
  padding-top: 25px;
  box-sizing: border-box;
}
.footermenu {
  display: flex;
  justify-content: left;
  align-items: center;
}
label {
  display: inline-block;
  width: 2px;
  height: 15px;
  background: #999999;
  margin: 0px 10px;
}
a {
  font-size: 14px;
  color: #333333;
}

.record {
  display: flex;
  align-items: center;
  color: #999;
}
.record_img {
  margin-right: 10px;
}
.link_style_none {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginFooter.vue